import { Spinner } from '@frontend/components/common';
import { FormattedMessage } from 'react-intl';
import QRCode from 'react-qr-code';

import { KioskNavigationHeader } from '../../components/kiosk-navigation-header.component';
import { useKioskNavigate } from '../../utils/kiosk-navigation';
import useReadPrivacyPolicy from './read-privacy-policy.controller';

const ID = 'read-privacy-policy';
const ReadPrivacyPolicy = () => {
    const viewProps = useReadPrivacyPolicy();
    const navigate = useKioskNavigate();

    return (
        <div
            className='bg-background-default flex size-full flex-col items-center justify-start overflow-hidden'
            id={ID}>
            <KioskNavigationHeader
                title={
                    <FormattedMessage
                        defaultMessage='Read privacy policy'
                        description='Button text for reading the privacy policy in the general info modal.'
                        id='generalInfoModal.readPrivacyPolicy'
                    />
                }
                onBack={() => navigate(-1)}
            />
            <div className='flex size-full flex-col items-start justify-start gap-3 overflow-y-auto px-6 py-4'>
                {viewProps.privacyLoading ? (
                    <Spinner />
                ) : (
                    <div className='flex flex-col items-start justify-start gap-3 self-stretch'>
                        <div className='text-foreground-default w-96 justify-end text-base font-medium'>
                            <FormattedMessage
                                defaultMessage='Scan the QR code below to view the privacy policy document.'
                                description='Instruction text for reading the privacy policy in the general info modal.'
                                id='generalInfoModal.readPrivacyPolicyDescription'
                            />
                        </div>
                        <div className='flex flex-col items-start justify-start gap-2 self-stretch'>
                            <div className='bg-background-surface border-border-default flex flex-col items-center justify-center gap-3 self-stretch rounded-xl border p-8'>
                                {viewProps.accountPrivacyDocument ? (
                                    <QRCode value={viewProps.accountPrivacyDocument} />
                                ) : (
                                    <div className='h-72 self-stretch bg-zinc-300' />
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ReadPrivacyPolicy;
